"use strict";

require("core-js/modules/es6.object.assign");

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-left: auto;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressModal = void 0;

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var styledTypes_1 = require("./styledTypes");

var LabelContainer = styledTypes_1.styled.div(_templateObject());
var LabelRight = styledTypes_1.styled.div(_templateObject2());

var ProgressModal = function ProgressModal(_a) {
  var visible = _a.visible,
      current = _a.current,
      total = _a.total,
      buildLeftLabel = _a.buildLeftLabel,
      buildRightLabel = _a.buildRightLabel,
      indeterminate = _a.indeterminate,
      modalProps = __rest(_a, ["visible", "current", "total", "buildLeftLabel", "buildRightLabel", "indeterminate"]);

  var theme = react_1["default"].useContext(styledTypes_1.ThemeContext);
  return react_1["default"].createElement(antd_1.Modal, Object.assign({
    visible: visible,
    footer: null,
    closable: false
  }, modalProps), react_1["default"].createElement(LabelContainer, null, buildLeftLabel ? react_1["default"].createElement("div", null, buildLeftLabel(current, total)) : null, buildRightLabel ? react_1["default"].createElement(LabelRight, null, buildRightLabel(current, total)) : null), react_1["default"].createElement(antd_1.Progress, {
    percent: indeterminate ? 100 : parseInt((current / total * 100).toFixed(0), 10),
    status: current !== total || indeterminate ? 'active' : undefined,
    showInfo: !indeterminate,
    strokeColor: indeterminate ? theme['@gray-3'] : undefined
  }));
};

exports.ProgressModal = ProgressModal;